<div class="signinContainer flex justify-start gap-0 overflow-hidden rounded-[20px] bg-white shadow-lg">
  <div class="imageSide bg-helper-two relative flex w-full flex-col items-center justify-center p-5">
    <img src="assets/forgetPassPic.png" alt="PIMS Logo" class="my-5 w-4/6" />
    <div class="welcomeText pb-5">
      <h1 class="textPrimaryColor text-center text-[32px] font-bold" i18n="@@forgotPasswordTitle">Forgot Password?</h1>
      <p class="mt-2 w-[345px] text-center text-[20px] font-extralight" i18n="@@forgotPasswordDescription">
        Enter your mobile number to receive a verification code to reset your password.
      </p>
    </div>
  </div>

  <div class="bg-bg flex w-full flex-col gap-4 px-10 py-5">
    <form [formGroup]="mobileForm" (ngSubmit)="onSubmit()" class="flex w-full flex-col gap-4">
      <div>
        <h1 class="text-[32px] font-semibold" i18n="@@forgotPasswordResetTitle">Reset Password</h1>
        <p class="text-[16px] font-normal" i18n="@@forgotPasswordEnterMobile">Please enter your mobile number</p>
      </div>
      @if (apiError()) {
        <div class="errortextcolor flex items-center gap-3 rounded-[12px] border border-red-400 bg-red-100 px-4 py-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 512 512">
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M256 42.667c117.803 0 213.334 95.53 213.334 213.333S373.803 469.334 256 469.334S42.667 373.803 42.667 256S138.197 42.667 256 42.667m48.918 134.25L256 225.836l-48.917-48.917l-30.165 30.165L225.835 256l-48.917 48.918l30.165 30.165L256 286.166l48.918 48.917l30.165-30.165L286.166 256l48.917-48.917z" />
          </svg>
          <div class="text-left">
            <h2 class="text-error text-[16px] font-semibold" i18n="@@forgotPasswordErrorTitle">Something went wrong</h2>
            <p class="text-error-soft text-[10px] font-light lg:text-[12px]">{{ apiError() }}</p>
          </div>
        </div>
      }

      <div>
        <app-mobile-input formControlName="phoneNumber" [error]="isFieldInvalid('phoneNumber')" />
        @if (hasError("phoneNumber", "required")) {
          <p class="mt-1 text-sm text-red-600" i18n="@@forgotPasswordPhoneRequired">Phone number is required</p>
        } @else if (hasError("phoneNumber", "invalidMobile")) {
          <p class="mt-1 text-sm text-red-600" i18n="@@forgotPasswordPhoneInvalid">
            Invalid phone number (must be 10 digits without the country code)
          </p>
        }
      </div>

      <div class="mt-3 flex w-full justify-end">
        <button type="submit" [disabled]="loading()" class="btn-primary">
          @if (loading()) {
            <span i18n="@@forgotPasswordButtonSending">SENDING...</span>
          } @else {
            <span i18n="@@forgotPasswordButtonSendOtp">SEND OTP</span>
          }
        </button>
      </div>
    </form>
    <div class="text-text-strong mt-auto flex flex-col items-center justify-center text-[16px]">
      <span i18n="@@forgotPasswordRemember">Remember your password?</span>
      <a
        routerLink="/login"
        class="text-text-strong cursor-pointer text-[14px] underline"
        i18n="@@forgotPasswordBackToLogin">
        Back to Login
      </a>
    </div>
  </div>
</div>
